import { Button, FormControl, FormLabel, Input, Option, Select, Stack, Typography } from '@mui/joy';
import React, { useEffect, useState } from 'react';
import { serviceFacade } from '../services/service-facade';
import { recentRoundsService } from '../services/recent-rounds-service';
import { useNavigate } from 'react-router';
import { CourseSummary } from '../models/course';

const CreateRound = () => {

    const [roundName, setRoundName] = useState('');
    const [playerName, setPlayerName] = useState('');
    const [courseId, setCourseId] = useState<string | null>(null);
    const [courses, setCourses] = useState<CourseSummary[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        serviceFacade.listCourses().then(setCourses).catch(() => {});
    }, []);

    const handleStartRound = async () => {
        try {
            setIsLoading(true);
            const response = await serviceFacade.createRound(roundName, playerName, courseId ?? undefined);
            const round = response.body.round;
            const player = response.body.player;
            recentRoundsService.updateRecentRounds(round.id, round.name, round.date, player.id, player.name, round.expires_at);
            navigate(`/${round.id}/${player.id}`);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Stack spacing={4}>
            <Typography level="h2">Create New Round</Typography>
            <FormControl>
                <FormLabel>Round Name</FormLabel>
                <Input
                    placeholder="Enter round name"
                    value={roundName}
                    onChange={(e) => setRoundName(e.target.value)}
                />
            </FormControl>
            <FormControl>
                <FormLabel>Player Name</FormLabel>
                <Input
                    placeholder="Enter your name"
                    value={playerName}
                    onChange={(e) => setPlayerName(e.target.value)}
                />
            </FormControl>
            <FormControl>
                <FormLabel>Course (optional)</FormLabel>
                <Select
                    placeholder="No course"
                    value={courseId}
                    onChange={(_, value) => setCourseId(value)}
                >
                    <Option value={null}>No course</Option>
                    {courses.map((course) => (
                        <Option key={course.id} value={course.id}>{course.name}</Option>
                    ))}
                </Select>
            </FormControl>
            <Button
                onClick={handleStartRound}
                loading={isLoading}
                disabled={isLoading}
            >
                Start Round
            </Button>
        </Stack>
    );
};
export default CreateRound;
